export default "__VITE_ASSET__BZASX4q8__"